import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { EventParticipationAnswerCreationModel } from 'src/app/models/event-participations/event-participation-answer-creation.model';
import { EventParticipationQuestionModel } from 'src/app/models/event-participations/event-participation-question.model';
import { AnswerTrainingQuestionsDialogComponent } from '../answer-training-questions-dialog/answer-training-questions-dialog.component';

@Component({
  selector: 'app-answer-training-additional-questions-modal',
  standalone: false,
  templateUrl: './answer-training-additional-questions-modal.component.html',
  styleUrl: './answer-training-additional-questions-modal.component.scss',
})
export class AnswerTrainingAdditionalQuestionsModalComponent {
  @ViewChild(AnswerTrainingQuestionsDialogComponent, { static: false })
  answerQuestionsDialogComponent!: AnswerTrainingQuestionsDialogComponent;

  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Input() 
  questions: EventParticipationQuestionModel[] = [];

  @Input()
  remainingParticipantSlots: number | null = null;

  @Output() 
  answersChange = new EventEmitter<EventParticipationAnswerCreationModel[]>();

  isTermsAccepted: boolean = false;

  onCancelClick() {
    this.closeModal()
  }

  acceptTraining() {
    const isValid = this.answerQuestionsDialogComponent.validate();

    if(isValid) {
      this.answersChange.emit(this.answerQuestionsDialogComponent.answers);
      this.closeModal()
    }
  }

  private closeModal() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }

  toggleCheckbox(checkbox: any) {
    checkbox.instance.option('value', !this.isTermsAccepted);
  }
}
